import React, { useMemo } from 'react';

import { ProductItem, Status } from 'components/Atoms';
import * as Molecules from 'components/Molecules';
import * as Atoms from 'components/Atoms';
import * as Organisms from 'components/Organisms';
import sizes from 'utils/screenSizes';

import searchIcon from 'assets/images/icons/search-icon.svg';

import { Container, ItemsContainer, InputContainer } from './styles';
import { IFilterCardapio } from './interfaces';

export const FilterCardapio: React.FC<IFilterCardapio> = ({
  filtersCategory,
  sizeWidth,
  inputSelected,
  inputSelectedMobile,
  handleClickInput,
  handlePressCategory,
  selectedCategoryId,
  ...rest
}) => {
  return (
    <Container
      inputSelected={inputSelected}
      inputSelectedMobile={inputSelectedMobile}
      {...rest}
    >
      <ItemsContainer sizeWidth={sizeWidth} inputSelected={inputSelected}>
        {filtersCategory.length > 0 &&
          filtersCategory.map(filterItem => (
            <Atoms.FilterCardapioItem
              isSelected={filterItem.id === selectedCategoryId}
              id={filterItem.name}
              key={filterItem.id}
              onClick={() =>
                handlePressCategory(
                  filterItem.id,
                  filterItem.positionCategoryContainer,
                )
              }
            >
              {filterItem.name}
            </Atoms.FilterCardapioItem>
          ))}
      </ItemsContainer>
      {(sizeWidth === 'desktop' || inputSelected) && (
        <InputContainer
          inputSelected={inputSelected}
          onClick={() => handleClickInput(!inputSelected)}
          inputSelectedMobile={inputSelectedMobile}
        >
          <Atoms.Input
            placeholder="Buscar"
            name="Buscar"
            id="search"
            label="Buscar"
            type="search"
          />
        </InputContainer>
      )}
    </Container>
  );
};
